import useIsMobile from '@/hooks/useIsMobile';
import OrderLineItemsCardDesktop from './desktop';
import OrderLineItemsCardMobile from './mobile';

const OrderLineItemsCard = () => {
    const isMobile = useIsMobile(992);
    return isMobile ? <OrderLineItemsCardMobile /> : <OrderLineItemsCardDesktop />;
};

export default OrderLineItemsCard;
